import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-payment-method'

export const getAll = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get`, {
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const update = async (token, id, status) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        id: id,
        status: status
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}
